import { ContentCopy } from '@mui/icons-material';
import { Alert, Box, IconButton, Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { copyToClipboard } from '../../common/utils/ui';

type Props = {
  password: string;
  hidden?: boolean;
  size: 'small' | 'large';
};

export const CopyPassword = ({ password, hidden, size }: Props) => {
  const [copiedTooltipOpen, setCopiedTooltipOpen] = useState(false);

  const onPasswordCopy = async () => {
    if (!password) return;

    await copyToClipboard(password);

    setCopiedTooltipOpen(true);
    setTimeout(() => setCopiedTooltipOpen(false), 2000);
  };

  const displayPassword = hidden ? '*'.repeat(16) : password;

  return (
    <Alert
      icon={false}
      severity="info"
      sx={{
        justifyContent: 'center',
        ...(size === 'small' ? { display: 'inline-block' } : {}),
        '& .MuiAlert-message': size === 'small' ? { fontSize: '1rem', padding: 0 } : { fontSize: '1.75rem' },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: hidden ? 'baseline' : 'center' }}>
        <Typography component="span" fontSize="inherit">
          {displayPassword}
        </Typography>
        <Tooltip title={t('copiedToClipboard')} open={copiedTooltipOpen}>
          <IconButton autoFocus size={size} onClick={onPasswordCopy} sx={{ ml: 2 }}>
            <ContentCopy fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
    </Alert>
  );
};
